import React from "react";
import { MessageCircle, Radio, Award, Zap } from "lucide-react";
import { waHref } from "./utils";

const USE_CASES = [
  { icon: Radio, title: "One-off tournament", desc: "Weekend league or single tournament coverage." },
  { icon: Award, title: "Season / league", desc: "3-6 months of regular club or academy matches." },
  { icon: Zap, title: "Full-year academy", desc: "Broadcast every training match all year round." },
];

export default function PricingContact() {
  return (
    <section id="pricing" className="py-20 bg-slate-900/40 border-y border-slate-800">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-600/15 border border-emerald-800 text-emerald-300 text-xs font-semibold uppercase tracking-wider mb-4">
          <MessageCircle size={12} /> Custom pricing on WhatsApp
        </div>
        <h2 className="font-heading text-4xl md:text-5xl font-black uppercase">Priced for your season</h2>
        <p className="text-slate-300 mt-4 max-w-xl mx-auto text-lg">
          Every club, academy and tournament is different. Message us on WhatsApp with a bit about your
          broadcast plan and we'll tailor a plan that fits your budget — from a single match to a full year.
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-3 text-left">
          {USE_CASES.map((f) => (
            <div key={f.title} className="p-5 rounded-xl bg-slate-800/60 border border-slate-700">
              <div className="w-10 h-10 rounded-lg bg-blue-600/15 border border-blue-800 flex items-center justify-center text-blue-400 mb-3">
                <f.icon size={18} />
              </div>
              <div className="font-heading font-extrabold uppercase text-white text-sm">{f.title}</div>
              <div className="text-slate-400 text-sm mt-1">{f.desc}</div>
            </div>
          ))}
        </div>

        <a href={waHref("Hi! I'd like to know the pricing for Cricket Graphics Studio. Here's a bit about my use case: ")}
          target="_blank" rel="noreferrer" data-testid="pricing-wa-cta"
          className="mt-10 inline-flex items-center gap-2 px-7 py-4 rounded-lg bg-emerald-600 hover:bg-emerald-700 font-bold text-lg shadow-lg shadow-emerald-900/50">
          <MessageCircle size={18} /> Message us on WhatsApp
        </a>
        <div className="text-slate-500 text-xs mt-3">Typically responds in under 30 minutes · Money-back on your first match</div>
      </div>
    </section>
  );
}
